import { Text } from '@podiumhq/design-system';

export const businessContent = (
  <Text color="black.base">
    Thanks for reaching out, Tori! We have a lot of options here. What’s your
    price range?
  </Text>
);

export const testimonialText =
  '“Webchat is easy to use. The conversation can continue after the customer leaves our website, giving them a convenient way to connect with us.”';

export const testimonialAttribution = 'Joe Ochs | Bray & Scarff';
